import { mapKeys } from 'lodash-es'

export const NEW = 'NEW'
export const UPDATE = 'UPDATE'
export const DONE = 'DONE'

export const TASK_VIEW_STATUSES = mapKeys(
  [
    { name: 'New', value: NEW },
    { name: 'Update', value: UPDATE },
    { name: 'Done', value: DONE },
  ],
  'value',
)
